import Transactions from "../components/Transactions";

export default function Index() {
    return(
        <div className="p-2">
            {/* <h1>Index</h1> */}
            <Transactions />
        </div>
    )
}